"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedoMigrationNotice = void 0;
const react_1 = require("react");
const nice_modal_react_1 = __importDefault(require("@ebay/nice-modal-react"));
const launchdarkly_react_client_sdk_1 = require("launchdarkly-react-client-sdk");
const AccountContext_1 = require("contexts/AccountContext");
const redo_migration_modal_component_1 = require("./redo-migration-modal.component");
const redo_migration_modal_constants_1 = require("./redo-migration-modal.constants");
nice_modal_react_1.default.register(redo_migration_modal_constants_1.REDO_MIGRATION_MODAL_ID, redo_migration_modal_component_1.RedoMigrationModal);
/**
 * Shows the Redo migration modal when LD flag `migrated-to-redo` is on
 * (exposed by the SDK as `flags.migratedToRedo`).
 */
const RedoMigrationNotice = () => {
    const { account } = (0, AccountContext_1.useAccount)();
    const flags = (0, launchdarkly_react_client_sdk_1.useFlags)();
    const promptedAccountIdRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const accountId = account === null || account === void 0 ? void 0 : account.id;
        if (!accountId || !flags.migratedToRedo) {
            nice_modal_react_1.default.remove(redo_migration_modal_constants_1.REDO_MIGRATION_MODAL_ID);
            return;
        }
        if ((0, redo_migration_modal_constants_1.isRedoMigrationNoticeDismissed)(accountId)) {
            return;
        }
        if (promptedAccountIdRef.current === accountId) {
            return;
        }
        promptedAccountIdRef.current = accountId;
        nice_modal_react_1.default.show(redo_migration_modal_constants_1.REDO_MIGRATION_MODAL_ID);
    }, [account === null || account === void 0 ? void 0 : account.id, flags.migratedToRedo]);
    return null;
};
exports.RedoMigrationNotice = RedoMigrationNotice;
